import { isApiError } from '../api/errors.ts';

export const UNREACHABLE = 'Sigora could not be reached.';

/**
 * The words for a failed account request. A refusal the server meant carries a message written
 * for the person at the form; anything else — a 5xx, a proxy's page, no connection at all — says
 * nothing they can act on beyond trying again.
 */
export const failureMessage = (failure: unknown): string =>
  isApiError(failure) && failure.status < 500 ? failure.message : UNREACHABLE;

/** The field a 400 `invalid_request` names in its `detail.field`, when it names one. */
export const refusedField = (failure: unknown): string | null =>
  isApiError(failure) &&
  failure.code === 'invalid_request' &&
  typeof failure.detail.field === 'string'
    ? failure.detail.field
    : null;

/**
 * Whether a link's token cannot be used: `invalid_token` for any token that does not work, or a
 * request that carried no token at all. Both leave the user needing a new link.
 */
export const isUnusableLink = (failure: unknown): boolean =>
  (isApiError(failure) && failure.code === 'invalid_token') || refusedField(failure) === 'token';
